import React from 'react'
import ArtworkDescriptionConnector, {
  ConnectorProps as ArtworkDescriptionProps,
} from '../../../connectors/ArtworkDescription'
import {
  DELIVERY_TIME_COPY,
  COUNTRIES_CUSTOMS_APPLICABLE,
  RETURN_POLICY_LINK,
  PACKAGING_GUIDELINES_LINK,
  ORIGINAL,
  ROLLED,
  FLAT_CRATE,
  ROLLED_IN_TUBE_TEXT,
  BOX_TEXT,
  CRATE_PACKAGING_TEXT,
} from '../../../helpers/constants'
import InfoTitleValue from '../components/InfoTitleValue/InfoTitleValue'
import styles from '../ArtworkDescription.module.scss'

const OriginalShippingAndReturns = (props: ArtworkDescriptionProps) => {
  const { category, currentTab, packingOption, isAple, shipsFromCountry } = props
  const isNotPhotography = category !== 'Photography'

  const getPackagingType = () => {
    if (packingOption === ROLLED) {
      return ROLLED_IN_TUBE_TEXT
    } else if (packingOption === FLAT_CRATE) {
      return CRATE_PACKAGING_TEXT
    } else return BOX_TEXT
  }

  if (currentTab !== ORIGINAL) {
    return null
  }

  return (
    <div className={styles.artworkInfoWrapper}>
      <div className={styles.artworkInfoContainer}>
        <InfoTitleValue title='Delivery Cost:' value='Shipping is included in price.' />
        <InfoTitleValue title='Delivery Time:' value={DELIVERY_TIME_COPY} />

        {category && (
          <InfoTitleValue
            title='Returns:'
            value={
              isNotPhotography && !isAple ? (
                <p className='defaultTypographyMedium'>
                  {`14-day return policy. Visit our `}
                  <a
                    className={styles.artworkInfoLink}
                    target='_blank'
                    rel='noopener noreferrer'
                    href={RETURN_POLICY_LINK}
                    title='help section'
                  >
                    help section
                  </a>
                  {` for more information.`}
                </p>
              ) : (
                <p className='defaultTypographyMedium'>
                  The purchase of photography and limited edition artworks as shipped by the artist
                  is final sale.
                </p>
              )
            }
          />
        )}

        {packingOption && (
          <InfoTitleValue
            title='Handling:'
            value={
              <p className='defaultTypographyMedium'>
                {`${getPackagingType()} Artists are responsible for packaging and adhering to Saatchi Art’s `}
                <a
                  className={styles.artworkInfoLink}
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PACKAGING_GUIDELINES_LINK}
                  title='packaging guidelines'
                >
                  packaging guidelines.
                </a>
              </p>
            }
          />
        )}

        {shipsFromCountry && <InfoTitleValue title='Ships From:' value={`${shipsFromCountry}.`} />}
        {shipsFromCountry && COUNTRIES_CUSTOMS_APPLICABLE.includes(shipsFromCountry) && (
          <InfoTitleValue
            title='Customs:'
            value={`Shipments from ${shipsFromCountry} may experience delays due to country's regulations for exporting valuable artworks.`}
          />
        )}
      </div>
    </div>
  )
}

export default ArtworkDescriptionConnector(OriginalShippingAndReturns)
